import { useFormik } from "formik";
import React from "react";
import { interest } from "../../utils/validators/schema";
import { useEffect } from "react";
import Select from "../form/select/Select";

const SavingsInterest = ({ accountingRef, coverRef, setInterest }) => {
  // const calculationType = [{label:"Simple Interest", value:"simple interest"}, {label:"Compound Interest", value:"compound interest"}];
  // const postingPeriod = [
  //   // {label:"Daily", value:"daily"},
  //   {label:"Monthly", value:"monthly"},
  //   {label:"Annually", value:"annually"},
  //   // {label:"Bi-Annually", values: "bi-annually"}
  // ];
  // const compoundingPeriod = [
  //   // {label:"Daily", value:"daily"},
  //   {label:"Monthly", value:"monthly"},
  //   {label:"Annually", value:"annually"},
  //   // {label:"Bi-Annually", value: "bi-annually"}
  // ];
  
  const onSubmit = (values) => {
    setInterest(values);
    accountingRef?.current?.click();
  };

  const { values, errors, touched, handleBlur, handleChange, handleSubmit, setFieldValue } =
    useFormik({
      enableReinitialize: true,
      initialValues: {
        default_interest_rate: "",
        minimum_interest_rate: "",
        maximum_interest_rate: "",
        // interest_cal_type:"",
        // interest_posting_period:"",
        // interest_compound_period:""
      },
      validationSchema: interest,
      onSubmit,
      validate: (values) => {
        const errors = {};
        // if (values.interest_posting_period === "daily" && values.interest_compound_period === "monthly") {
        //   errors.interest_compound_period = "Compound period cannot be monthly if Posting period is Daily"
        // }
        // if (!values.interest_cal_type) {
        //   errors.interest_cal_type = "Interest Calculation Type is required";
        // }
        // if (!values.interest_posting_period) {
        //   errors.interest_posting_period = "Interest Posting Period is required";
        // }
        // if (!values.interest_compound_period) {
        //   errors.interest_compound_period = "Interest Compound Period is required";
        // }
        if (
          parseFloat(values?.default_interest_rate) <
          parseFloat(values?.minimum_interest_rate)
        ) {
          errors.minMax = "Default rate cannot be less than minimum rate";
        }
        if (
          parseFloat(values?.default_interest_rate) >
          parseFloat(values?.maximum_interest_rate)
        ) {
          errors.minMax = "Default rate cannot be greater than maximum rate";
        }
        if (
          parseFloat(values?.maximum_interest_rate) <
          parseFloat(values?.minimum_interest_rate)
        ) {
          errors.minMax = "Minimum rate cannot be greater than maximum rate";
        }
        return errors;
      },
    });

  useEffect(() => {
    setInterest(values);
  }, [values]);

  return (
    <form className='row' onSubmit={handleSubmit}>
      <div className='col-md-4 mb-3'>
        <label htmlFor='default_rate'>
          Default rate <span className='text-danger'>*</span>
        </label>
        <input
          type='text'
          className={`form-control ${
            errors?.default_interest_rate &&
            touched?.default_interest_rate &&
            "is-invalid"
          }`}
          name='default_interest_rate'
          id='default_interest_rate'
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='0.00'
        />
        {errors?.default_interest_rate && touched?.default_interest_rate && (
          <span className='text-danger'>{errors?.default_interest_rate}</span>
        )}
      </div>
      <div className='col-md-4 mb-3'>
        <label htmlFor='default_rate'>
          Minimum rate <span className='text-danger'>*</span>
        </label>
        <input
          type='text'
          className={`form-control ${
            errors?.minimum_interest_rate &&
            touched?.minimum_interest_rate &&
            "is-invalid"
          }`}
          name='minimum_interest_rate'
          id='minimum_interest_rate'
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='0.00'
        />
        {errors?.minimum_interest_rate && touched?.minimum_interest_rate && (
          <span className='text-danger'>{errors?.minimum_interest_rate}</span>
        )}
      </div>
      <div className='col-md-4 mb-3'>
        <label htmlFor='default_rate'>
          Maximum rate <span className='text-danger'>*</span>
        </label>
        <input
          type='text'
          className={`form-control ${
            errors?.maximum_interest_rate &&
            touched?.maximum_interest_rate &&
            "is-invalid"
          }`}
          name='maximum_interest_rate'
          id='maximum_interest_rate'
          onChange={handleChange}
          onBlur={handleBlur}
          placeholder='0.00'
        />
        {errors?.maximum_interest_rate && touched?.maximum_interest_rate && (
          <span className='text-danger'>{errors?.maximum_interest_rate}</span>
        )}
      </div>
      <div className=''>
        {errors?.minMax &&
          touched?.maximum_interest_rate &&
          touched?.minimum_interest_rate && (
            <p className='alert alert-warning'>{errors?.minMax}</p>
          )}
      </div>
        {/* <div className='col-md-4'>
          <div className='mb-3'>
            <label htmlFor='simpleinput' className='form-label'>
                Interest Calculation Type <span className='text-danger'>*</span>
            </label>
            <Select
              isError={
                errors?.interest_cal_type && touched?.interest_cal_type && !values?.interest_cal_type
              }
              name='interest_cal_type'
              data={calculationType}
              value={values.interest_cal_type}
              onChange={(selectedOption) =>
                setFieldValue("interest_cal_type", selectedOption?.value)
              }
              onBlur={() => handleBlur({ target: { name: "interest_cal_type" } })}
            />
            {errors?.interest_cal_type && touched?.interest_cal_type && !values?.interest_cal_type && (
              <p className='text-danger mb-0'>{errors?.interest_cal_type}</p>
            )}
          </div>
        </div>
        <div className='col-md-4'>
          <div className='mb-3'>
            <label htmlFor='simpleinput' className='form-label'>
                Interest Posting Period <span className='text-danger'>*</span>
            </label>
            <Select
              isError={
                errors?.interest_posting_period && touched?.interest_posting_period && !values?.interest_posting_period
              }
              name='interest_posting_period'
              data={postingPeriod}
              value={values.interest_posting_period}
              onChange={(selectedOption) =>
                setFieldValue("interest_posting_period", selectedOption?.value)
              }
              onBlur={() => handleBlur({ target: { name: "interest_posting_period" } })}
            />
            {errors?.interest_posting_period && touched?.interest_posting_period && !values?.interest_posting_period && (
              <p className='text-danger mb-0'>{errors?.interest_posting_period}</p>
            )}
          </div>
        </div>
        <div className='col-md-4'>
          <div className='mb-3'>
            <label htmlFor='simpleinput' className='form-label'>
                Interest Compounding Period <span className='text-danger'>*</span>
            </label>
            <Select
              isError={
                errors?.interest_compound_period && touched?.interest_compound_period && !values?.interest_compound_period
              }
              name='interest_compound_period'
              data={compoundingPeriod}
              value={values.interest_compound_period}
              onChange={(selectedOption) =>
                setFieldValue("interest_compound_period", selectedOption?.value)
              }
              onBlur={() => handleBlur({ target: { name: "interest_compound_period" } })}
            />
            {errors?.interest_compound_period && touched?.interest_compound_period && (
              <p className='text-danger mb-0'>{errors?.interest_compound_period}</p>
            )}
          </div>
        </div> */}
      <div className='mt-4 d-flex justify-content-end'>
        <button
          type='button'
          className='btn btn-info text-white me-3'
          onClick={() => coverRef?.current?.click()}
        >
          <i className='mdi mdi-arrow-left me-1'></i>
          Previous
        </button>
        <button type='submit' className='btn btn-primary text-white '>
          Next <i className='mdi mdi-arrow-right ms-1'></i>
        </button>
      </div>
    </form>
  );
};

export default SavingsInterest;
